import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import rootReducer from './modules'

export const history = createHistory()

const enhancers = []
const logger = store => next => action => {
  let result = next(action)
  // console.log('action.type:', action.type)
  // console.log("store: ",store.getState().data)
  if(action.type === 'CLOSE_FULL_DETAILS' ||
     action.type === 'OPEN_SKILL' ||
     action.type === 'OPEN_PERSON' ||
     action.type === 'TOGGLE_FULL_DETAILS') null
  else if(action.type !== 'CHECK_CONNECTION_FILTER' && action.type !== 'UPDATE_NODES_AND_LINKS'){
    store.dispatch({type: 'CHECK_CONNECTION_FILTER'})
    store.dispatch({type: 'UPDATE_NODES_AND_LINKS'})
  }

  return result
}

const middleware = [
  thunk,
  routerMiddleware(history),
  logger
]

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  rootReducer,
  composedEnhancers
)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js